import {MESSAGE_SHOW_TIME_VALUE,SUBMIT_FIAL_TIME_VALUE} from '@/config/index';
import { ElMessage,ElMessageBox } from 'element-plus';

/**
 * 提示
 */

function messageErrorGetDataIsNull() {
    ElMessage({
        message: '获取数据为空;',
        duration: MESSAGE_SHOW_TIME_VALUE,
        type: 'error',
    });
}
function messageErrorGetDataIsFailed() {
    ElMessage({
        message: '获取数据失败;',
        duration: MESSAGE_SHOW_TIME_VALUE,
        type: 'error',
    });
}
function messageErrorSelectList() {
    ElMessage({
        message: '请选择数据;',
        duration: MESSAGE_SHOW_TIME_VALUE,
        type: 'error',
    });
}
function messageErrorNoRightView() {
    ElMessage({
        message: '没有权限查看;',
        duration: MESSAGE_SHOW_TIME_VALUE,
        type: 'error',
    });
}
function messageErrorNoRightOperate() {
    ElMessage({
        message: '没有权限操作;',
        duration: MESSAGE_SHOW_TIME_VALUE,
        type: 'error',
    });
}
function messageSuccessOperate() {
    ElMessage({
        message: '操作成功;',
        duration: MESSAGE_SHOW_TIME_VALUE,
        type: 'success',
    });
}

/**
 * 提示-验证的错误信息
 */
function messageErrorValidate(val:any) {
    ElMessage({
        dangerouslyUseHTMLString:true,
        message: val.join('<br/>'),
        /**duration: MESSAGE_SHOW_TIME_VALUE,*/
        type: 'error',
        customClass: 'my-message-min-width'
    });
}

/**
 * 弹出框
 */
function messageBoxSelectList() {
    ElMessageBox({
        title: '提示',
        message: '请选择数据;', 
        type: 'error',
      });
}

/**
 * 弹出框
 */
function messageBoxOperationFailed() {
    ElMessageBox({
        title: '提示',
        message: '操作失败;', 
        type: 'error',
      });
}

/**弹出框-错误信息 */
function messageBoxError(val:string) {
    ElMessageBox({
        title: '提示',
        message: val, 
        type: 'error',
      });
}
/**错误提示信息 */
function messageError(val:string) {
    ElMessage({
        message: val,
        duration: MESSAGE_SHOW_TIME_VALUE,
        type: 'error',
    });
}


/**
 * 导出
 */
export default {
    messageErrorGetDataIsNull,
    messageErrorGetDataIsFailed,
    messageErrorSelectList,
    messageErrorNoRightOperate,
    messageErrorNoRightView,
    messageSuccessOperate,
    messageErrorValidate,
    messageBoxOperationFailed,
    messageBoxSelectList,
    messageBoxError,

    messageError
}